import { Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 24,
  padding: '48px 24px',
  width: '100%',
});

export const IconTile = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.grey[0], 0.1),
  borderRadius: 12,
  padding: 12,
  gap: 5,
  color: theme.palette.grey[50],
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Message = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  lineHeight: 1.6,
  textAlign: 'center',
  color: alpha(theme.palette.grey[0], 0.7),
}));
